
import { 
  DriverSalaryAdjustmentsDetail, DriverSalaryAdjustmentsDetailRequest,
} from "../../types"
import { ApiDriverSalaryAdjustments } from "services";
import { 
  driverSalaryAdjustmentsDetailCreate,
  driverSalaryAdjustmentsDetailDelete,
  driverSalaryAdjustmentsDetailEdit,
  driverSalaryAdjustmentsDetailList,
  driverSalaryAdjustmentsDetailOne
} from "../../actions";
import { makeRequestWithSpinner } from "worker";
import { ActionPromise } from "bus/rootActions";
import { PayloadRequest } from "types/requestTypes";

export function* fetchDriverSalaryAdjustmentsWorkerDetail (action: ActionPromise<DriverSalaryAdjustmentsDetail[], PayloadRequest>): Generator {
    try {
        const options = {
            fetcher: ApiDriverSalaryAdjustments.getDriverSalaryAdjustmentsDetailList,
            startFetching: driverSalaryAdjustmentsDetailList.start,
            stopFetching: driverSalaryAdjustmentsDetailList.stop,
            fill: driverSalaryAdjustmentsDetailList.fill,
            setErrorAction: driverSalaryAdjustmentsDetailList.error,
            fetcherParam: action.payload
        }

        const result = yield makeRequestWithSpinner<DriverSalaryAdjustmentsDetail[], PayloadRequest>(options);
        yield action.resolve(result as DriverSalaryAdjustmentsDetail[]);
    } catch(e) {
        
    }
}


export function* fetchDriverSalaryAdjustmentsWorkerDetailOne (action: ActionPromise<DriverSalaryAdjustmentsDetail, PayloadRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.getDriverSalaryAdjustmentsDetailOne,
          startFetching: driverSalaryAdjustmentsDetailOne.start,
          stopFetching: driverSalaryAdjustmentsDetailOne.stop,
          fill: driverSalaryAdjustmentsDetailOne.fill,
          setErrorAction: driverSalaryAdjustmentsDetailOne.error,
          fetcherParam: action.payload
      }

      const result = yield makeRequestWithSpinner<DriverSalaryAdjustmentsDetail, PayloadRequest>(options);
      yield action.resolve(result as DriverSalaryAdjustmentsDetail);
  } catch(e) {
      
  }
}



export function* fetchDriverSalaryAdjustmentsWorkerDetailCreate (action: ActionPromise<void, DriverSalaryAdjustmentsDetailRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.createDriverSalaryAdjustmentsDetail,
          startFetching: driverSalaryAdjustmentsDetailCreate.start,
          stopFetching: driverSalaryAdjustmentsDetailCreate.stop,
          fill: driverSalaryAdjustmentsDetailCreate.fill,
          setErrorAction: driverSalaryAdjustmentsDetailCreate.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, DriverSalaryAdjustmentsDetail>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}

export function* fetchDriverSalaryAdjustmentsWorkerDetailEdit (action: ActionPromise<void, DriverSalaryAdjustmentsDetailRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.editDriverSalaryAdjustmentsDetail,
          startFetching: driverSalaryAdjustmentsDetailEdit.start,
          stopFetching: driverSalaryAdjustmentsDetailEdit.stop,
          fill: driverSalaryAdjustmentsDetailEdit.fill,
          setErrorAction: driverSalaryAdjustmentsDetailEdit.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, DriverSalaryAdjustmentsDetail>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}


export function* fetchDriverSalaryAdjustmentsWorkerDetailDelete (action: ActionPromise<void, PayloadRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.deleteDriverSalaryAdjustmentsDetail,
          startFetching: driverSalaryAdjustmentsDetailDelete.start,
          stopFetching: driverSalaryAdjustmentsDetailDelete.stop,
          fill: driverSalaryAdjustmentsDetailDelete.fill,
          setErrorAction: driverSalaryAdjustmentsDetailDelete.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, PayloadRequest>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}